import { ChartOptions } from "chart.js"
import { GAUGE_ROTATION, GAUGE_CIRCUMFERENCE } from "./const"

export const fixedOptions: ChartOptions<"doughnut"> = {
  elements: {
    arc: {
      borderWidth: 6,
      hoverBorderColor: `#ffffff`,
    },
  },
  responsive: true,
  aspectRatio: 2,
  maintainAspectRatio: false,
  rotation: GAUGE_ROTATION,
  circumference: GAUGE_CIRCUMFERENCE,
  cutout: 80,
  plugins: {
    title: {
      display: false,
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      padding: {
        top: 8,
        right: 10,
        bottom: 8,
        left: 10,
      },
      titleFont: { weight: `bold`, size: 24, family: `'MessinaSansCondensed', sans-serif` },
      titleMarginBottom: 2,
      bodyFont: { weight: `bold`, size: 16, family: `'MessinaSansCondensed', sans-serif` },
    },
  },
}
